<template>
  <div class="home" @scroll="handleScroll" :class="{ 'scrolled': isScrolled, 'scrolledBack': isScrolledBack }">
    <nav class="navbar">
      <div class="logo global-btn" @click="home">51Card</div>
      <button v-if="!userInfo.nickname" class="login global-btn glowing-box" @click="showDialogView">登录</button>
      <a-dropdown v-else @select="handleSelect">
        <button class="login global-btn glowing-box">
          设置
          <icon-down/>
        </button>
        <template #content>
          <a-doption :value="1">订阅服务</a-doption>
          <a-doption :value="2">退出</a-doption>
        </template>
      </a-dropdown>
    </nav>

    <div class="hero">
      <h1 style="margin-bottom: -30px;">51Card</h1>
      <h1 style="margin-bottom: -20px;margin-top: 20px;">轻松订阅</h1>
      <div class="typing-container">
        <span class="typing-text">{{ displayText }}</span>
        <span class="cursor">|</span>
      </div>
      <div>
        <button class="primary global-btn glowing-box" @click="!userInfo.nickname ? showDialogView() : toDashBoard()">
          立即体验
        </button>
      </div>
      <div>
        <button class="secondary global-btn glowing-box" @click="toService">常见问题</button>
      </div>

      <div class="floating-icons">
        <img v-for="(icon, index) in icons"
             :key="index"
             :src="icon.src"
             :style="icon.style"
             class="icon">
      </div>

      <div class="floating-icons">
        <img v-for="(icon, index) in icons1"
             :key="index"
             :src="icon.src"
             :style="icon.style"
             class="icon1">
      </div>
    </div>

<!--    <div style="display: flex; align-items: center; justify-content: center;margin-bottom: 100px;">-->
<!--      <img :src="require('@/assets/ucards/cards_f.png')" class="card-front shan-scroller">-->
<!--      <img :src="require('@/assets/ucards/cards_b.png')" class="card-front shan-scroller" style="margin-left: 80px;">-->
<!--    </div>-->

    <div
        style="display: flex; flex-direction:column; align-items: center; justify-content: center;margin-bottom: 60px;">
      <img :src="require('@/assets/service/fly.png')" class="fly-png">
      <div class="fly-font">优质服务</div>
    </div>

    <div
        style="display: flex; align-items: start; justify-content: center;margin-bottom: 40px;flex-wrap: wrap;flex-direction: row;">
      <img v-for="(icon, index) in icons2"
           :key="index"
           :src="icon.src"
           :style="icon.style"
           class="icon2">
    </div>

<!--    <div-->
<!--        style="display: flex; align-items: center; justify-content: center;margin-bottom: 40px;flex-direction: column;">-->
<!--      <h2 class="fly-font">简单注册</h2>-->
<!--      <div class="flex">-->
<!--        <a-space>-->
<!--          <a-image :src="require('@/assets/login/img.png')" :width="200"></a-image>-->
<!--          <a-image :src="require('@/assets/login/img_1.png')" :width="200"></a-image>-->
<!--        </a-space>-->
<!--      </div>-->
<!--      <h2 class="fly-font">零门槛支付</h2>-->
<!--      <div class="flex">-->
<!--        <a-space>-->
<!--          <a-image :src="require('@/assets/login/pay.jpg')" :width="400" :height="200"></a-image>-->
<!--          <a-image :src="require('@/assets/login/pay-1.png')" :width="400" :height="200"></a-image>-->
<!--        </a-space>-->
<!--      </div>-->
<!--    </div>-->

    <div>
      <a-modal v-model:visible="showXieyi" :width="850">
        <template #title>
          用户协议与服务条款
        </template>
        <div v-html="contentInfo.content">
        </div>
      </a-modal>
    </div>

    <!-- 注册登录 -->
    <!-- 遮罩层 -->
    <div v-if="showDialog" class="overlay" @click="closeDialog"></div>
    <!-- 弹出框 -->
    <div v-if="showDialog" class="dialog">
      <span class="close-btn" @click="closeDialog">x</span>
      <div v-if="isLogin">
        <h3 class="title">登录</h3>
        <div class="input-group">
          <input type="text" v-model="email" placeholder="请输入邮箱">
        </div>
        <div class="input-group">
          <input :type="showPassword ? 'text' : 'password'" v-model="password" placeholder="请输入登录密码">
          <icon-eye v-if="showPassword" class="toggle" @click="showPassword = !showPassword"/>
          <icon-eye-invisible v-else class="toggle" @click="showPassword = !showPassword"/>
        </div>
        <button class="login-btn" @click="login">登录</button>
        <div class="agreement">
          <input type="checkbox" v-model="agree">
          <label>我已阅读并同意 <a href="#" @click="showXieyiView">《用户协议与服务条款》</a></label>
        </div>
        <!-- <p class="register">我还没有账户 <span @click="register">去注册</span></p>-->
      </div>
      <div v-else>
        <h3 class="title">注册</h3>
        <div class="input-group">
          <input type="text" v-model="email" placeholder="请输入邮箱">
        </div>
        <div class="input-group">
          <input type="text" v-model="smsCode" placeholder="请输入邮箱验证码">
          <a-spin :loading="spinningLoading">
          <span class="global-btn pr-10" :style="!disabled ? 'color: #007bff;' : 'color: gray'"
                @click="!disabled ? nextEmail() : ''">{{
              text
            }}</span>
          </a-spin>
        </div>
        <div class="input-group">
          <input :type="showPassword ? 'text' : 'password'" v-model="password1" placeholder="请输入登录密码">
          <icon-eye v-if="showPassword1" class="toggle" @click="showPassword1 = !showPassword1"/>
          <icon-eye-invisible v-else class="toggle" @click="showPassword1 = !showPassword1"/>
        </div>
        <div class="input-group">
          <input :type="showPassword2 ? 'text' : 'password'" v-model="password2" placeholder="请重复输入登录密码">
          <icon-eye v-if="showPassword2" class="toggle" @click="showPassword2 = !showPassword2"/>
          <icon-eye-invisible v-else class="toggle" @click="showPassword2 = !showPassword2"/>
        </div>
        <button class="login-btn" @click="registerBtn">注册</button>
        <p class="register">已有账号 <span @click="isLogin = true">去登录</span></p>
      </div>
    </div>
    <!-- 底部栏-->
    <PageFooter></PageFooter>
  </div>
</template>

<script>
import gsap from "gsap";
import {IconDown, IconEye, IconEyeInvisible} from '@arco-design/web-vue/es/icon';
import sendVerifyCode from '@/utils/SendVerifyCode'
import {emailCaptcha, getUserInfo, loginEmail, registerEmail} from "@/api/user";
import {getArticleDetails} from "@/api/api";
import PageFooter from "@/components/footer/Footer.vue";

export default {
  components: {IconEye, IconEyeInvisible, IconDown, PageFooter},
  data() {
    return {
      icons: [
        {src: require("@/assets/card/amazon.png"), style: {top: "3%", left: "10%"}},
        // {src: require("@/assets/card/apple.png"), style: {top: "6%", left: "30%"}},
        {src: require("@/assets/card/claude.png"), style: {top: "45%", left: "22%"}},
        {src: require("@/assets/card/cursor.png"), style: {top: "90%", left: "10%"}},
        {src: require("@/assets/card/discord.png"), style: {top: "85%", left: "32%"}},
      ],
      icons1: [
        {src: require("@/assets/card/facebook.png"), style: {top: "5%", left: "65%"}},
        {src: require("@/assets/card/github.png"), style: {top: "8%", left: "85%"}},
        // {src: require("@/assets/card/google.png"), style: {top: "45%", left: "80%"}},
        {src: require("@/assets/card/openAI.png"), style: {top: "90%", left: "70%"}},
        {src: require("@/assets/card/poe.png"), style: {top: "85%", left: "85%"}},
      ],
      icons2: [
        {src: require("@/assets/service/a.png")},
        {src: require("@/assets/service/b.png")},
        {src: require("@/assets/service/c.png")},
        {src: require("@/assets/service/d.png")},
        {src: require("@/assets/service/e.png")},
        // {src: require("@/assets/service/f.png")},
        {src: require("@/assets/service/g.png")},
        {src: require("@/assets/service/h.png")},
        {src: require("@/assets/service/aa.png")},
        {src: require("@/assets/service/bb.png")},
        {src: require("@/assets/service/cc.png")},
        {src: require("@/assets/service/dd.png")},
        {src: require("@/assets/service/ee.png")},
        {src: require("@/assets/service/ff.png")},
        {src: require("@/assets/service/gg.png")},
        {src: require("@/assets/service/hh.png")},
        {src: require("@/assets/service/j.png")},
        {src: require("@/assets/service/k.png")},
        {src: require("@/assets/service/l.png")},
        {src: require("@/assets/service/m.png")},
        {src: require("@/assets/service/n.png")},
        {src: require("@/assets/service/o.png")},
        {src: require("@/assets/service/p.png")},
        {src: require("@/assets/service/q.png")},
        {src: require("@/assets/service/r.png")},
        {src: require("@/assets/service/s.png")},
        {src: require("@/assets/service/t.png")},
        {src: require("@/assets/service/u.png")},
        {src: require("@/assets/service/v.png")},
        {src: require("@/assets/service/w.png")},
        {src: require("@/assets/service/x.png")},
        {src: require("@/assets/service/y.png")},
        {src: require("@/assets/service/z.png")},
      ],
      texts: ["OpenAI", "ChatGpt", "Alibaba Cloud", "Amazon"], // 需要循环展示的文本
      displayText: "", // 当前显示的文本
      textIndex: 0, // 当前正在显示的文本索引
      charIndex: 0, // 当前字符索引
      isDeleting: false, // 是否正在删除
      typingSpeed: 150, // 文字出现速度
      pauseTime: 1000, // 完整显示后的停顿时间
      isScrolled: false, // 是否滚动超过指定高度
      scrollThreshold: 300, // 触发变色的滚动高度
      isScrolledBack: false,
      scrollThresholdBack: 900, // 触发变色的滚动高度
      showDialog: false,
      showPassword: false,
      showPassword1: false,
      showPassword2: false,
      email: "",
      password: "",
      password1: "",
      password2: "",
      smsCode: "",
      agree: false,
      isLogin: true,
      isSend: true,
      spinningLoading: false,
      userInfo: {},
      contentInfo: {},
      showXieyi: false,
    };
  },
  watch: {
    '$store.getters.token': {
      handler(newVal, oldVal) {
        this.$nextTick(() => {
          if (!newVal) {
            this.userInfo = {}
            this.$router.push('/')
          }
        })
      }
    },
  },
  mixins: [sendVerifyCode],
  mounted() {
    this.typeEffect();
    window.addEventListener("scroll", this.handleScroll);
  },
  created() {
    let user = localStorage.getItem('USER_INFO')
    if (user) {
      this.userInfo = JSON.parse(user)
    }
    this.getArticleDetailsInfo()
  },
  methods: {
    showXieyiView() {
      this.showXieyi = true
    },
    getArticleDetailsInfo() {
      let id = 44
      getArticleDetails(id).then(res => {
        this.contentInfo = res.data;
      }).catch(() => {
            // 这里不用再处理错误，错误已经在拦截器里处理了
          });
    },
    handleSelect(e) {
      if (e === 1) {
        this.toDashBoard()
      }
      if (e === 2) {
        this.logout()
      }
    },
    logout() {
      this.$store.dispatch('GETLOGOUT')
    },
    login() {
      let that = this
      if (!this.agree) {
        this.$message.error('请勾选用户协议');
        return;
      }
      if (!this.email) {
        this.$message.error('请输入邮箱');
        return
      }
      if (!/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/.test(this.email)) {
        return this.$message.error('请输入正确的邮箱');
      }
      if (!this.password) {
        this.$message.error('请输入密码');
        return
      }
      this.spinningLoading = true
      loginEmail({
        email: that.email,
        password: that.password,
      })
          .then(res => {
            if (res.code === 200) {
              that.$store.commit('LOGIN', {'token': res.data.token})
              that.getUserInfo(res.data)
              this.spinningLoading = false
            } else {
              this.spinningLoading = false
              this.errorLogin = res.message
            }
          })
          .catch(e => {
          })

    },
    nextEmail() {
      if (!this.email) {
        this.$message.error('请输入邮箱');
        return
      }
      if (!/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/.test(this.email)) {
        return this.$message.error('请输入正确的邮箱');
      }
      this.spinningLoading = true
      emailCaptcha(this.email)
          .then(res => {
            if (res.code === 200) {
              this.sendCode()
              this.spinningLoading = false
            } else {
              this.spinningLoading = false
              this.$message.error(res.message);
            }
          }).catch(() => {
        // 这里不用再处理错误，错误已经在拦截器里处理了
      });
    },
    registerBtn() {
      let that = this
      if (!this.email) {
        this.$message.error('请输入邮箱');
        return
      }
      if (!/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/.test(this.email)) {
        return this.$message.error('请输入正确的邮箱');
      }
      if (!this.smsCode) {
        this.$message.error('请输入邮箱验证码');
        return
      }
      if (!this.password1) {
        this.$message.error('请输入密码');
        return
      }
      if (!this.password2) {
        this.$message.error('请重复输入密码');
        return
      }
      if (this.password2 !== this.password1) {
        this.$message.error('俩次密码输入不相同');
        return
      }
      registerEmail({
        email: this.email,
        captcha: this.smsCode,
        password: this.password1,
        invitationCode: ''
      })
          .then(res => {
            if (res.code === 200) {
              that.$store.commit('LOGIN', {
                'token': res.data.token
              })
              that.getUserInfo(res.data)
            } else {
              that.$message.error(res.message);
            }
          }).catch(() => {
        // 这里不用再处理错误，错误已经在拦截器里处理了
      });
    },
    getUserInfo(data) {
      let that = this
      that.$store.commit('SETUID', data.id)
      getUserInfo()
          .then(res => {
            that.$store.commit('UPDATE_USERINFO', res.data)
            return that.$router.replace({path: '/dashboard'})
          }).catch(() => {
        // 这里不用再处理错误，错误已经在拦截器里处理了
      });
    },
    register() {
      this.isLogin = false
    },
    showDialogView() {
      this.email = ''
      this.smsCode = ''
      this.password = ''
      this.isLogin = true
      this.showDialog = true;
    },
    closeDialog() {
      this.showDialog = false;
    },
    home() {
      this.$router.push({path: "/"});
    },
    toDashBoard() {
      this.$router.push({path: "/dashboard"});
    },
    toService() {
      this.$router.push({path: "/service"});
    },
    typeEffect() {
      let currentText = this.texts[this.textIndex]; // 获取当前文本
      if (!this.isDeleting) {
        // 逐字打印
        this.displayText = currentText.substring(0, this.charIndex + 1);
        this.charIndex++;
        if (this.charIndex === currentText.length) {
          this.isDeleting = true;
          setTimeout(this.typeEffect, this.pauseTime); // 停顿后开始删除
          return;
        }
      } else {
        // 逐字删除
        this.displayText = currentText.substring(0, this.charIndex);
        this.charIndex--;
        if (this.charIndex === 0) {
          this.isDeleting = false;
          this.textIndex = (this.textIndex + 1) % this.texts.length; // 切换到下一个文本
        }
      }
      setTimeout(this.typeEffect, this.typingSpeed);
    },
    handleScroll() {
      let scrollY = window.scrollY;
      gsap.to(".icon", {
        y: scrollY * 0.5,
        x: scrollY * -0.5,
        opacity: 1 - scrollY / 500,
        scale: 1 - scrollY / 1000
      });
      gsap.to(".icon1", {
        y: scrollY * 0.5,
        x: scrollY * 0.5,
        opacity: 1 - scrollY / 500,
        scale: 1 - scrollY / 1000
      });
      this.isScrolled = scrollY > this.scrollThreshold;
      this.isScrolledBack = scrollY > this.scrollThresholdBack;
    }
  },
  beforeDestroy() {
    window.removeEventListener("scroll", this.handleScroll);
  }
};
</script>

<style scoped>
/* 关闭按钮 */
.close-btn {
  position: absolute;
  top: 15px;
  right: 25px;
  font-size: 20px;
  cursor: pointer;
  width: 30px;
  height: 30px;

  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #cccccc;
  border-radius: 50%;
}

/* 标题 */
.title {
  font-size: 28px;
  font-weight: bold;
  margin-bottom: 35px;
}

/* 输入框 */
.input-group {
  display: flex;
  align-items: center;
  border: 1px solid #ccc;
  padding: 8px;
  margin-bottom: 25px;
  height: 46px;
  border-radius: 15px;
}

.input-group input {
  flex: 1;
  border: none;
  outline: none;
  padding: 5px;
}

.prefix {
  margin-right: 8px;
  color: #333;
}

.toggle {
  cursor: pointer;
  padding-right: 10px;
  font-size: 26px;
  color: #333333;
}

/* 按钮 */
.login-btn {
  width: 100%;
  background: #007bff;
  color: white;
  padding: 10px;
  border: none;
  height: 56px;
  border-radius: 15px;
  cursor: pointer;
  margin-top: 10px;
  margin-bottom: 20px;
  font-size: 24px;
}

.alt-login {
  width: 100%;
  background: none;
  border: none;
  color: #007bff;
  cursor: pointer;
  margin-top: 10px;
}

/* 复选框 */
.agreement {
  display: flex;
  align-items: center;
  font-size: 16px;
  margin: 10px 0;
}

.agreement a {
  color: #007bff;
  text-decoration: none;
}

/* 注册 */
.register {
  margin-top: 60px;
  font-size: 16px;
  color: #666;
}

.register span {
  color: #007bff;
  cursor: pointer;
}

/* 打开按钮 */
.open-btn {
  padding: 10px 15px;
  background: #007bff;
  color: white;
  border: none;
  border-radius: 5px;
  cursor: pointer;
}

/* 弹出框 */
.dialog {
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background: white;
  padding: 50px;
  border-radius: 28px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.2);
  z-index: 999;
  width: 550px;
  text-align: center;
}

/* 遮罩层 */
.overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  z-index: 998;
}

.card-front {
  margin-top: 260px;
  border-radius: 26px;

  width: 743px !important;
  height: 461px !important;
}

.scrolled {
  background: #333333 !important;
  color: white;
}

.scrolledBack {
  background: #d8e8f7 !important;
  color: black !important;
}

.fly-png {
  width: 60px;
  height: 60px;
  margin-bottom: 10px;
}

.fly-font {
  font-size: 42px;
  font-weight: bold;
}

.home {
  background: #d8e8f7;
  overflow-x: hidden;
}

.logo {
  font-size: 32px;
  margin-left: 20px;
}

.login {
  height: 42px;
  margin-right: 40px;
  padding-right: 20px;
  padding-left: 20px;
  border-radius: 25px;
  border: 1px solid #d8e8f7;
  font-size: 20px;
  background: #333333;
  color: #ffffff;
  box-shadow: 0 0 10px rgba(255, 255, 255, 0.8); /* 白色发光 */
}

.navbar {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  display: flex;
  justify-content: space-between;
  padding: 10px;
  height: 64px;
  align-items: center;
}

.hero {
  position: relative;
  text-align: center;
  margin-top: 160px;

  color: #333333;
  font-size: 52px !important;
  font-weight: bold;
}

.floating-icons .icon {
  position: absolute;
  width: 100px;
  transition: transform 0.5s ease-out;
}

.floating-icons .icon1 {
  position: absolute;
  width: 100px;
  transition: transform 0.5s ease-out;
}

.icon2 {
  width: 130px;
  height: 150px;
  margin-left: 15px;
  margin-bottom: 20px;
}

.typing-container {
  margin-top: 40px;
}

.primary {
  margin-top: 50px;
  background: #3189ef;
  color: white;
  height: 82px;
  padding-right: 80px;
  padding-left: 80px;
  border-radius: 45px;
  border: 1px solid #d8e8f7;
  font-size: 36px;
}

.secondary {
  margin-top: 30px;
  background: white;
  color: black;
  height: 82px;
  padding-right: 80px;
  padding-left: 80px;
  border-radius: 45px;
  border: 1px solid #d8e8f7;
  font-size: 36px;
}
</style>
